import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormDataDivider from '../../../FormFields/FormDataDivider';
import FormPhoneNumberField from '../../../FormFields/FormPhoneNumField';
import FormTextField from '../../../FormFields/FormTextField';
import FormNumberField from '../../../FormFields/FormNumberField';
import FormVendorField from '../../../FormFields/FormVendorField';
import FormTitle from '../../../FormFields/FormTitle';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { HR } from '../../../formQuestionsEnum';
import { OUTSOURCED_COMPANY_CATEGORIES } from '../../../optionEnums';
import { validateEmail } from '../../../ValidateFunctions';

DietarySection.propTypes = {
  permissions: PropTypes.object,
};

export default function DietarySection({ permissions }) {
  const {
    data: { outsourcedCompanyCategoriesList },
  } = useSelector((state) => state.transitions);
  const { watch } = useFormContext();
  const isOutsourced = watch(HR.DIETARY_IS_OUTSOURCED.fieldName);
  const [focusedField, setFocusedField] = useState(null);

  return (
    [
      HR.DIETARY_IS_OUTSOURCED.id,
      HR.DIETARY_OUTSOURCED_CATEGORY_ID.id,
      HR.OUTSOURCED_DIETARY_VENDOR.id,
      HR.DIETARY_OUTSOURCED_PHONE.id,
      HR.DIETARY_OUTSOURCED_EMAIL.id,
      HR.DIETARY_OUTSOURCED_HOURS_PER_WEEK.id,
      HR.DIETARY_OUTSOURCED_COMP_HAS_HR_FILES.id,
    ].some((id) => id in permissions) && (
      <>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">
            Dietary
          </Typography>
        </Grid>
        {HR.DIETARY_IS_OUTSOURCED.id in permissions && (
          <Grid item xs={12}>
            <FormTitle fieldAttributes={{ questionTitle: 'Department type' }} />
            <FormButtonOptions
              fieldName={HR.DIETARY_IS_OUTSOURCED.fieldName}
              fieldAttributes={{
                isEditable: permissions[HR.DIETARY_IS_OUTSOURCED.id],
                options: [
                  { label: 'Outsourced', value: true },
                  { label: 'In House', value: false },
                ],
              }}
            />
          </Grid>
        )}

        {isOutsourced === true && (
          <>
            {HR.DIETARY_OUTSOURCED_CATEGORY_ID.id in permissions && (
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Choose Category' }} />
                <FormButtonOptions
                  fieldName={HR.DIETARY_OUTSOURCED_CATEGORY_ID.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[HR.DIETARY_OUTSOURCED_CATEGORY_ID.id],
                    options: outsourcedCompanyCategoriesList.filter(
                      (x) =>
                        x.value === OUTSOURCED_COMPANY_CATEGORIES.FULL_DEPARTMENT ||
                        x.value === OUTSOURCED_COMPANY_CATEGORIES.MANAGER_ONLY
                    ),
                  }}
                />
              </Grid>
            )}

            {HR.OUTSOURCED_DIETARY_VENDOR.id in permissions && (
              <Grid item xs={12}>
                <FormTitle
                  fieldAttributes={{
                    questionTitle: 'Dietary outsourced company',
                    fieldType: 'title',
                  }}
                />
                <FormVendorField
                  fieldName={HR.OUTSOURCED_DIETARY_VENDOR.fieldName}
                  fieldAttributes={{ isEditable: permissions[HR.OUTSOURCED_DIETARY_VENDOR.id] }}
                  invoiceFileTypeId={FILE_TYPES.DIETARY_OUTSOURCED_COMPANY_INVOICE}
                  contractFileTypeId={FILE_TYPES.DIETARY_OUTSOURCED_COMPANY_CONTRACT}
                />
              </Grid>
            )}

            {HR.DIETARY_OUTSOURCED_PHONE.id in permissions && (
              <Grid item xs={12} md={5}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Phone' }} />
                  <FormPhoneNumberField
                    fieldName={HR.DIETARY_OUTSOURCED_PHONE.fieldName}
                    fieldAttributes={{ isEditable: permissions[HR.DIETARY_OUTSOURCED_PHONE.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}

            {HR.DIETARY_OUTSOURCED_EMAIL.id in permissions && (
              <Grid item xs={12} md={5}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Email' }} />
                  <FormTextField
                    fieldName={HR.DIETARY_OUTSOURCED_EMAIL.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[HR.DIETARY_OUTSOURCED_EMAIL.id],
                      validation: {
                        pattern: { ...validateEmail },
                      },
                    }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}

            {HR.DIETARY_OUTSOURCED_HOURS_PER_WEEK.id in permissions && (
              <Grid item xs={12} md={2}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Hours per week' }} />
                  <FormNumberField
                    fieldName={HR.DIETARY_OUTSOURCED_HOURS_PER_WEEK.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[HR.DIETARY_OUTSOURCED_HOURS_PER_WEEK.id],
                    }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                    allowDecimal
                  />
                </FieldContainer>
              </Grid>
            )}

            {HR.DIETARY_OUTSOURCED_COMP_HAS_HR_FILES.id in permissions && (
              <Grid item xs={12}>
                <FormTitle
                  fieldAttributes={{ questionTitle: 'Does the contracted company have their own HR files?' }}
                />
                <FormButtonOptions
                  fieldName={HR.DIETARY_OUTSOURCED_COMP_HAS_HR_FILES.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[HR.DIETARY_OUTSOURCED_COMP_HAS_HR_FILES.id],
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                  }}
                />
              </Grid>
            )}
          </>
        )}
        <FormDataDivider />
      </>
    )
  );
}
